var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcontwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.627,
    viewBox: "0 0 18 14.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(51,51,51,0.78);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,6.167a7.372,7.372,0,0,1-2.121.582A3.7,3.7,0,0,0,19.5,4.706a7.4,7.4,0,0,1-2.345.9,3.694,3.694,0,0,0-6.388,2.526,3.734,3.734,0,0,0,.1.841A10.483,10.483,0,0,1,3.252,5.111a3.7,3.7,0,0,0,1.143,4.93A3.685,3.685,0,0,1,2.722,9.58v.046a3.693,3.693,0,0,0,2.962,3.621,3.694,3.694,0,0,1-.973.129,3.76,3.76,0,0,1-.694-.066,3.7,3.7,0,0,0,3.45,2.565A7.451,7.451,0,0,1,2,17.4,10.455,10.455,0,0,0,7.66,19.063,10.434,10.434,0,0,0,18.166,8.556q0-.24-.01-.478A7.515,7.515,0,0,0,20,6.167Z",
    transform: "translate(-1.999 -4.436)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontwitter);
export default __webpack_public_path__ + "static/media/icon twitter.fef7d98cecbe2c95d82bbbdb81234828.svg";
export { ForwardRef as ReactComponent };